export default __webpack_public_path__ + "static/desk-property03-02a4ab425a95c6a27cb0dbbceb1f0843.jpg";